import React from 'react';

import { Typography } from 'antd-v5';
import type { TitleProps as AntTitleProps } from 'antd-v5/es/typography/Title';
import cn from 'classnames';
import fonts from 'scouting-ui/lib/scss/_fonts.scss';
import type { ColorType } from 'scouting-ui/lib/types';

type HeadingFonts =
  | 'display-h1'
  | 'display-h2'
  | 'display-h3'
  | 'display-h4'
  | 'display-h5';

interface HeadingProps extends AntTitleProps {
  font?: HeadingFonts;
  color?: ColorType;
}

const Heading: React.FC<HeadingProps> = props => {
  const { font: fontProp, level = 4, color, style, ...otherProps } = props;
  const fontsForLevel: Record<number, HeadingFonts> = {
    1: 'display-h1',
    2: 'display-h2',
    3: 'display-h3',
    4: 'display-h4',
    5: 'display-h5',
  };

  const font = fontProp || fontsForLevel[level];
  const colorProp = color ? `var(--${color})` : undefined;
  const fontClass = font ? fonts[`text-${font}`] : undefined;
  return (
    <Typography.Title
      style={{ color: colorProp, ...style }}
      className={cn(fontClass)}
      level={level}
      {...otherProps}
    />
  );
};

export default Heading;
